import React, { useState } from "react";
import './WebDesign.css';
import consulting from './assets/consulting .jpg';
import consultingapproach from './assets/consultingapproach.avif';

const Consulting = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Consulting</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Consulting</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Consulting & Strategy – Shaping Your Business’s Digital Future</h2>
                            <p>Navigating the complex digital world can be overwhelming, but you don’t have to do it alone. Our Consulting & Strategy services provide expert advice and actionable strategies to help your business thrive. Whether you're looking to improve your digital presence, streamline operations, or enhance customer experiences, we work closely with you to create a roadmap for success.</p>
                            <h3>Why Consulting & Strategy Matter</h3>
                            <p>A well-thought-out strategy is essential for sustained digital success. Without a clear plan, businesses may struggle with inefficiencies, ineffective marketing, and missed opportunities. Our expert consultants analyze market trends, consumer behaviors, and business needs to craft tailored solutions that drive measurable growth.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={consulting} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={consultingapproach} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Consulting Approach</h3>                                
                                <ol>
                                    <li><b>Business Analysis & Goal Setting:</b> Understanding your business needs, goals, and challenges.</li>
                                    <li><b>Digital Transformation:</b> Implementing modern technology to optimize operations.</li>
                                    <li><b>Market Research & Competitive Analysis:</b> Identifying trends and positioning your brand for success.</li>
                                    <li><b>Strategy Execution & Optimization:</b> Implementing, monitoring, and refining strategies for long-term success.</li>
                                </ol>
                                <h3 className="mt-5">What We Offer</h3>                                
                                <ol>
                                    <li><b>Digital Transformation Consulting:</b> Modernizing your business for the digital age.</li>
                                    <li><b>Market Research & Competitive Analysis:</b> Data-driven insights for a competitive edge.</li>
                                    <li><b>Business Strategy & Planning:</b> Long-term growth strategies tailored to your needs.</li>
                                    <li><b>Roadmaps for Digital Growth and Long-Term Success:</b> Actionable plans to ensure sustained progress.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>With the right strategy in place, your business can scale efficiently and adapt to evolving digital landscapes. Let Dot Localhost help you shape a successful digital future.</p>
                    </section>

                </div>
            </div>

        </>
    );
};

export default Consulting;